import { Directive, ElementRef, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';

/**
 * Due to a webkit bug related to ion-input with automatic filling of
 * fields you will need a workaround with this directive.
 * https://capacitorjs.com/docs/guides/autofill-credentials
 * https://gist.github.com/dtarnawsky/fc92869c1c67b9c74c66de8af3e081b2
 */
@Directive({
    selector: '[ridangoAutofill]'
})
export class AutofillDirective implements OnInit {
    constructor(private el: ElementRef) {}

    ngOnInit(): void {
        if (Capacitor.getPlatform() !== 'ios') {
            return;
        }
        setTimeout(() => {
            try {
                this.el.nativeElement.children[0].addEventListener('change', (e) => {
                    this.el.nativeElement.value = (e.target as any).value;
                });
                // eslint-disable-next-line no-empty
            } catch {}
        }, 100); // Need some time for the ion-input to create the input element
    }
}
